<script type="text/ecmascript-6">
    import DesignerQuestionPanelCategory from "./DesignerQuestionPanelCategory.vue";
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionPanelCategory,
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Panel Category';
                }
            },
        },
    }
</script>
